var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12835",
    "data-name": "Group 12835",
    transform: "translate(907 -6856)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-907 6856)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-868 6895.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4417",
    "data-name": "Path 4417",
    d: "M38.6,0H13.772A6.793,6.793,0,0,0,7,6.772V20.317h6.772a6.678,6.678,0,0,1,1.987-4.786,6.91,6.91,0,0,1,9.572,0L32.1,22.3a6.842,6.842,0,0,1,0,9.572L25.33,38.647a6.827,6.827,0,0,1-9.572,0,6.678,6.678,0,0,1-1.987-4.786H7V47.406a6.793,6.793,0,0,0,6.772,6.772H38.6a6.793,6.793,0,0,0,6.772-6.772V6.772A6.793,6.793,0,0,0,38.6,0Z",
    transform: "translate(8.802)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4418",
    "data-name": "Path 4418",
    d: "M30.679,19.292,27.744,22.2a2.276,2.276,0,0,0,0,3.206,2.336,2.336,0,0,0,3.206,0l6.772-6.772a2.35,2.35,0,0,0,0-3.206L30.95,8.66a2.267,2.267,0,0,0-3.206,3.206l2.935,2.912H2.257a2.257,2.257,0,1,0,0,4.515Z",
    transform: "translate(0 10.054)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.56b0272b0931289048d3c198e289ba3c.svg";
export { ForwardRef as ReactComponent };